import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";

export interface WorkspaceRole {
  id: number;
  organization_id: number | null;
  name: string;
  permissions: string[];
  rank: number;
}

export interface WorkspaceRolesResponse {
  workspace_id: number;
  roles: WorkspaceRole[];
}

/**
 * List RBAC roles available inside a specific workspace. Resolves to
 * the workspace organization's roles (RBAC is org-scoped).
 */
export const useWorkspaceRoles = (workspaceId: number | null) => {
  const userToken = useAuth()?.userToken;
  return useQuery<WorkspaceRolesResponse>({
    queryKey: ["workspaces", workspaceId, "roles"],
    enabled: workspaceId !== null && Boolean(userToken),
    queryFn: async () =>
      fetch(ENDPOINTS.identity.workspace_roles(workspaceId!), {
        headers: { Authorization: `Bearer ${userToken ?? ""}` },
      }).then(handleResponse),
  });
};
